import React from 'react';

import Images from "../../components/Images/Images";

import "../../styles/pages/market_place/market_place.scss";

export const MarketPlaceCover = ({ title, image }) => {
  return (
    <div className="mp-block mp-cover">
      <div className="mp-cover__description" dangerouslySetInnerHTML={{ __html: title }} />
      <div className="mp-cover__image">
        <Images 
          sources={{
            mb: { url: image.xs.url },
            sm: { url: image.md.url },
            md: { url: image.lg.url },
            lg: { url: image.url },
            url: image.url
          }}
          alt="Market Place Cover Image"
          loading="eager"
        />
      </div>
    </div>
  )
};
